// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Button, Icon, Menu, Ref } from "semantic-ui-react";
import "./ApplicationLauncherListItem.less";
import { ApplicationLauncherContext } from "./ApplicationLauncherContext";
import { ApplicationLauncherPopup } from "./ApplicationLauncherPopup";
import { Link } from "../../services/router";
import { getApplicationClassName } from "../utils/className";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const className = getApplicationClassName("launcher", "list", "item");
export const ApplicationLauncherListItem = props => {
  const {
    children,
    name,
    code,
    icon,
    libelle,
    path,
    ...rest
  } = props;
  const {
    setOpen
  } = React.useContext(ApplicationLauncherContext);
  const innerRef = React.useRef();
  const handleMouseDown = React.useCallback(() => {
    innerRef.current?.scrollIntoView();
  }, []);
  const handleClick = React.useCallback(() => {
    React.startTransition(() => {
      setOpen(false);
    });
  }, [setOpen]);
  const content = React.useMemo(() => /*#__PURE__*/_jsx(Ref, {
    innerRef: innerRef,
    children: /*#__PURE__*/_jsxs(Button, {
      fluid: true,
      onMouseDown: handleMouseDown
      // eslint-disable-next-line react/jsx-props-no-spreading
      ,
      ...(path && {
        as: Link,
        to: path,
        onClick: handleClick
      }),
      "data-testid": name,
      className: code,
      children: [/*#__PURE__*/_jsx("aside", {
        children: /*#__PURE__*/_jsx(Icon, {
          name: icon,
          variant: "solid"
        })
      }), /*#__PURE__*/_jsx("span", {
        children: libelle
      })]
    })
  }), [libelle, name, code, icon, path, handleClick, handleMouseDown]);
  const popup = React.useMemo(() => /*#__PURE__*/_jsx(ApplicationLauncherPopup, {
    code: code,
    trigger: content,
    children: children
  }), [children, content, code]);
  return React.useMemo(() => /*#__PURE__*/_jsx(Menu.Item, {
    className: className
    // eslint-disable-next-line react/jsx-props-no-spreading
    ,
    ...rest,
    children: path ? content : popup
  }), [content, popup, path, rest]);
};